import { Box, BoxProps, Text } from "@chakra-ui/react";
import type { ReactNode } from "react";

export function FormTitle({
  children,
  ...rest
}: { children: ReactNode } & BoxProps) {
  return (
    <Box w="100%" {...rest}>
      <Text mb="8px" lineHeight="1.2" fontSize="17px" fontWeight="semibold">
        {children}
      </Text>
      <Box
        w="100%"
        borderTop="1px solid var(--chakra-colors-gray-200)"
        mb="12px"
      />
    </Box>
  );
}
